import { useState } from 'react';
import {
  Box,
  Collapse,
  Flex,
  Icon,
  Text,
  useColorModeValue,
} from '@chakra-ui/react';
import { FiChevronDown, FiChevronRight } from 'react-icons/fi';

import VehicleTableHtml from './VehicleTableHtml';

interface PolicyCoverageSectionProps {
  html: string | null;
  defaultExpanded?: boolean;
}

const PolicyCoverageSection = ({
  html,
  defaultExpanded = true,
}: PolicyCoverageSectionProps) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);
  const borderColor = useColorModeValue('gray.200', 'gray.600');
  const headerBg = useColorModeValue('gray.50', 'gray.700');
  const hoverBg = useColorModeValue('gray.100', 'gray.600');

  if (!html) {
    return null;
  }

  return (
    <Box mb={4}>
      <Flex
        bg={headerBg}
        px={3}
        py={2}
        borderWidth="1px"
        borderColor={borderColor}
        borderRadius="md"
        borderBottomRadius={isExpanded ? 0 : 'md'}
        justify="space-between"
        align="center"
        cursor="pointer"
        _hover={{ bg: hoverBg }}
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <Flex align="center" gap={2}>
          <Icon
            as={isExpanded ? FiChevronDown : FiChevronRight}
            boxSize={4}
            color="gray.500"
          />
          <Text fontWeight="600" fontSize="sm">
            Policy Coverage
          </Text>
        </Flex>
      </Flex>

      <Collapse in={isExpanded} animateOpacity>
        <Box
          borderWidth="1px"
          borderTopWidth="0"
          borderColor={borderColor}
          borderBottomRadius="md"
          p={4}
        >
          <VehicleTableHtml html={html} />
        </Box>
      </Collapse>
    </Box>
  );
};

export default PolicyCoverageSection;
